<h2 mat-dialog-title class="modal-header">
    Duplication de l'épreuve {{data.race.name}}
</h2>

<mat-dialog-content>

    <p>Lors de la duplication de l'épreuve, les points de chrométrage associés seront également dupliqués</p>

    <form [formGroup]="duplicateFg" (ngSubmit)="submit()">

        <!-- Champ : Nom de l'épreuve -->
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Nom de l'épreuve</mat-label>
            <input matInput type="text" formControlName="name" placeholder="ex: Trail des Crêtes (Copie)">
            <mat-hint align="end">{{ duplicateFg.get('name')?.value?.length || 0 }}/150</mat-hint>

            @if (duplicateFg.get('name')?.invalid && duplicateFg.get('name')?.touched) {
            <mat-error>{{ getErrorMessage('name') }}</mat-error>
            }
        </mat-form-field>

        <!-- Champ : Slug de l'épreuve -->
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Slug de l'épreuve</mat-label>
            <input matInput type="text" formControlName="slug" placeholder="ex: trail-des-cretes-copie">
            <mat-hint>Identifiant unique pour l'URL</mat-hint>
            <mat-hint align="end">{{ duplicateFg.get('slug')?.value?.length || 0 }}/50</mat-hint>

            @if (duplicateFg.get('slug')?.invalid && duplicateFg.get('slug')?.touched) {
            <mat-error>{{ getErrorMessage('slug') }}</mat-error>
            }
        </mat-form-field>

        <!-- Champ : Date et Heure de départ -->
        <mat-form-field appearance="outline" class="w-100">
            <mat-label>Date et heure de départ</mat-label>
            <input matInput type="datetime-local" formControlName="startTime">
            <mat-hint>Format : JJ/MM/AAAA HH:MM</mat-hint>

            @if (duplicateFg.get('startTime')?.invalid && duplicateFg.get('startTime')?.touched) {
            <mat-error>{{ getErrorMessage('startTime') }}</mat-error>
            }
        </mat-form-field>

        <!-- Actions -->
        <div class="d-flex flex-row justify-content-center p-2 gap-3">
            <button mat-flat-button color="primary" type="submit" [disabled]="duplicateFg.invalid">
                Dupliquer l'épreuve
            </button>
            <button mat-stroked-button type="button" [mat-dialog-close]="false">
                Annuler
            </button>
        </div>
    </form>

</mat-dialog-content>